<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-danger fade show" role="alert" v-if="destroyed">
            Device deleted! Return to <router-link :to="{ name: 'Devices'}" class="alert-link">Devices</router-link>
          </div>
        </div>
      </div>

      <!-- Device -->
      <div class="row">
        <div class="col-sm-4">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-mobile"></i><strong>Device</strong>
            </div>
            <div class="card-block">

              <div class="form-group">
                <label for="identifier">Identifier</label>
                <input type="text" class="form-control" id="identifier" v-model="device.identifier" readonly>
              </div>

              <div class="form-group">
                <label for="merchant">Merchant</label>
                <input type="text" class="form-control" id="merchant" v-model="device.merchant" readonly>
              </div>

              <div class="form-group">
                <label for="locale">Locale</label>
                <input type="text" class="form-control" id="locale" v-model="device.locale" readonly>
              </div>

              <div class="form-group" v-if="device.app">
                <label for="version">App</label>
                <router-link :to="{ name: 'App', params: {id: device.app.id} }" v-if="device.app"><input type="text" class="form-control" id="locale" v-model="device.app.uid" readonly></router-link>
              </div>

              <div class="form-group" v-if="device.app">
                <label for="version">App Version</label>
                <input type="text" class="form-control" id="version" v-model="device.version" readonly>
              </div>

              <div class="form-group" v-if="device.app">
                <label for="created_at">Creation Date</label>
                <input type="text" class="form-control" id="created_at" :value="device.created_at | moment('LLL')" readonly>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="card" v-if="device.os">
            <div class="card-header">
              <i class="fa fa-android" v-if="device.os.name=='Android'"></i>
              <i class="fa fa-apple" v-if="device.os.name=='iPhone OS' || device.os.name=='iOS'"></i>
              <strong>Operating System</strong>
            </div>
            <div class="card-block">

              <div class="form-group">
                <label for="os_name">Name</label>
                <input type="text" class="form-control" id="os_name" v-model="device.os.name" readonly>
              </div>

              <div class="form-group">
                <label for="os_version">Version</label>
                <input type="text" class="form-control" id="os_version" v-model="device.os.version" readonly>
              </div>
            </div>
          </div>

          <div class="card" v-if="device.cor3">
            <div class="card-header">
              <i class="fa fa-puzzle-piece"></i><strong>Cor3</strong>
            </div>
            <div class="card-block">
              <div class="form-group">
                <label for="cor3_min">Minimum Version</label>
                <input type="text" class="form-control" id="cor3_min" v-model="device.cor3.GetFilesVersions.all_files[0]" readonly>
              </div>

              <div class="form-group">
                <label for="cor3_max">Max Version</label>
                <input type="text" class="form-control" id="cor3_max" v-model="device.cor3.GetFilesVersions.all_files[1]" readonly>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="card" v-if="device.hardware">
            <div class="card-header">
              <i class="fa fa-microchip"></i><strong>Hardware</strong>
            </div>
            <div class="card-block">

              <div class="form-group">
                <label for="manufacturer">Manufacturer</label>
                <input type="text" class="form-control" id="manufacturer" v-model="device.hardware.manufacturer" readonly>
              </div>

              <div class="form-group">
                <label for="model">Model</label>
                <input type="text" class="form-control" id="model" v-model="device.hardware.model" readonly>
              </div>

              <div class="form-group">
                <label for="gpu_extension">GPU Extension</label>
                <input type="text" class="form-control" id="gpu_extension" v-model="device.hardware.gpu_extension" readonly>
              </div>

              <div class="form-group">
                <label for="texture_format">Texture Format</label>
                <input type="text" class="form-control" id="texture_format" v-model="device.hardware.texture_format" readonly>
              </div>
            </div>
          </div>

          <!-- Batch -->
          <div class="card">
            <div class="card-header">
              <i class="fa fa-bullhorn"></i><strong>Push Notification</strong>
            </div>
            <div class="card-block">
              <div class="form-group">
                <label for="manufacturer">Push Token</label>
                <input type="text" class="form-control" id="manufacturer" v-model="device.push_token" readonly>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sessions -->
      <div class="row" v-if="!destroyed">
        <div class="col-sm-12">
          <div class="card" v-if="sessions">
            <div class="card-header">
              <strong>Sessions</strong>
            </div>
            <div class="card-block">
              <device-sessions v-bind:deviceID="device.id" v-if="device.id"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Usage Rights -->
      <div class="row" v-if="!destroyed">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <strong>Usage Rights</strong>
              <span class="badge badge-default" v-if="revision">Revision {{revision}}</span>
            </div>
            <div class="card-block">
              <device-usage-rights v-bind:device="device" v-if="device.id" v-on:bump-revision="getRevision"/>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" @click="addUsageRightModal=true"><i class="fa fa-plus"></i> New Usage Right</button>
              <button class="btn btn-warning" @click="bumpRevision"><i class="fa fa-level-up"></i> Bump Revision</button>
           </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!destroyed">
        <div class="col-sm-12">
          <div class="form-group">
            <button type="button" class="btn btn-danger" @click="openDestroyModal"><i class="fa fa-trash"></i> Destroy</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Usage Right -->
    <modal class="modal" large v-model="addUsageRightModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Search Products</h4>
      </div>
      <search-products v-bind:device="device"/>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="addUsageRightModal = false">Close</button>
      </div>
    </modal>

    <!-- Migrate Usage Right -->
    <modal class="modal" large v-model="migrateUsageRightModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Migrate Usage Right</h4>
      </div>
        <migrate-usage-right v-bind:usageRight="modalContext.usageRight" v-bind:currentDevice="device" v-if="modalContext.usageRight" :key="modalContext.usageRight"/>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="migrateUsageRightModal = false">Close</button>
      </div>
    </modal>

  </div>
</template>

<script>
import DeviceUsageRights from 'components/devices/DeviceUsageRights'
import DeviceSessions from 'components/devices/DeviceSessions'
import SearchProducts from 'components/devices/SearchProducts'
import MigrateUsageRight from 'components/devices/MigrateUsageRight'
import {EventBus} from 'services/eventBus'
import devices from 'services/devices'
import modal from 'vue-strap/src/Modal'

export default {
  name: 'device',
  data () {
    return {
      device: {},
      revision: null,
      sessions: [],
      usageRights: [],
      addUsageRightModal: false,
      migrateUsageRightModal: false,
      modalContext: {},
      destroyed: false
    }
  },
  created () {
    this.getDevice()
    this.getRevision()

    EventBus.$on('migrate-usageright-modal', event => {
      this.modalContext.usageRight = event.usageRight
      this.migrateUsageRightModal = true
    })
  },
  methods: {
    getDevice () {
      devices.get(this, this.$route.params.id)
    },
    getRevision () {
      devices.revision(this, this.$route.params.id)
    },
    destroyDevice () {
      devices.destroy(this, this.device.id).then(response => {
        this.destroyed = true
        window.scrollTo(0, 0)
      })
    },
    bumpRevision () {
      devices.bumpRevision(this, this.device.id).then(response => {
        this.getRevision()
        EventBus.$emit('alert-modal', {
          title: 'Success!',
          message: 'Device revision is now bumped!'
        })
      })
    },
    openDestroyModal () {
      EventBus.$emit('destroy-modal', {
        name: this.device.identifier,
        confirm: this.destroyDevice
      })
    }
  },
  components: {
    DeviceUsageRights,
    SearchProducts,
    DeviceSessions,
    MigrateUsageRight,
    modal
  }
}
</script>



// WEBPACK FOOTER //
// src/views/devices/Device.vue